// $.getJSON("https://cdn.shopify.com/s/files/1/0589/4340/6260/t/2/Config/settings_data.json", function(json) {
//     console.log(json); // this will show the info it in firebug console
// });


function storeinfo(){
  
  var storename = "Intrigue Jewelers";
  var phone1 = "(334) 826-0612";
  var email = "intriguej@aol.com";
  
  var storeaddress = `Auburn Mall 1627 Opelika Road suite 11`
  var city = `Auburn`
  var state = `AL`
  var zip = `36830`
  var region =`Auburn`
         
  var storehours = `Mon - Sat: 10:00AM - 8:00PM <br>Sun: 12:00PM - 6:00PM`
  
  var newdate = new Date();
  var Establishedyear = newdate.getFullYear() - 1993
  
  var storenameurl = window.location.origin;
  var address = ` ${storeaddress} <br> ${city}, ${state} ${zip} `
  

  var Xstorename = document.getElementsByClassName("storename");
  for(var i=0; i< Xstorename.length; i++){
    //console.log(Xstorename[i].nodeName)
    Xstorename[i].innerHTML = storename;
    if(Xstorename[i].nodeName == 'A'){
      Xstorename[i].setAttribute('href', storenameurl);
    }
  }

  var Xphone1 = document.getElementsByClassName("phone1");
  for(var i=0; i< Xphone1.length; i++){
    //console.log(Xphone1[i].nodeName)
    Xphone1[i].innerHTML = phone1;
    if(Xphone1[i].nodeName == 'A'){
      Xphone1[i].setAttribute('href',`tel:${phone1}`);
    }
  }

  var Xemail = document.getElementsByClassName("email");
  for(var i=0; i< Xemail.length; i++){
    //console.log(Xemail[i].nodeName)
    Xemail[i].innerHTML = email;
    if(Xemail[i].nodeName == 'A'){
      Xemail[i].setAttribute('href',`mailto:${email}`);
    }
  }

  var Xaddress = document.getElementsByClassName("address");
  for(var i=0; i< Xaddress.length; i++){
    //console.log(Xaddress[i].nodeName)
    Xaddress[i].innerHTML = address;
    //   if(Xaddress[i].nodeName == 'A'){
    //       Xaddress[i].setAttribute('href', addressurl);
    //   }
  }
  
   var Xstoreaddress = document.getElementsByClassName("storeaddress");
  for(var i=0; i< Xstoreaddress.length; i++){
    Xstoreaddress[i].innerHTML = storeaddress;
  }
  
  var Xcity = document.getElementsByClassName("city");
  for(var i=0; i< Xcity.length; i++){
    Xcity[i].innerHTML = city;
   
  }

  var Xstate = document.getElementsByClassName("state");
  for(var i=0; i< Xstate.length; i++){
    Xstate[i].innerHTML = state;
  }

  var Xzip = document.getElementsByClassName("zip");
  for(var i=0; i< Xzip.length; i++){
    Xzip[i].innerHTML = zip;
  }

  
  var Xstorehours = document.getElementsByClassName("storehours");
  for(var i=0; i< Xstorehours.length; i++){
    //console.log(Xaddress[i].nodeName)
    Xstorehours[i].innerHTML = storehours;
    //   if(Xaddress[i].nodeName == 'A'){
    //       Xaddress[i].setAttribute('href', addressurl);
    //   }
  }
  
      
  var Xregion = document.getElementsByClassName("region");
  for(var i=0; i< Xregion.length; i++){
    //console.log(Xaddress[i].nodeName)
    Xregion[i].innerHTML = region;
    //   if(Xaddress[i].nodeName == 'A'){
    //       Xaddress[i].setAttribute('href', addressurl);
    //   }
  }


  var XEstablishedyear = document.getElementsByClassName("Establishedyear");
  for(var i=0; i< XEstablishedyear.length; i++){
    //console.log(Xaddress[i].nodeName)
    XEstablishedyear[i].innerHTML = Establishedyear;
    //   if(Xaddress[i].nodeName == 'A'){
    //       Xaddress[i].setAttribute('href', addressurl);
    //   }
  }
  
  
}

// window.addEventListener('load', function(){
// 	storeinfo(); 
//     var clickOnMapLeft = document.querySelector('.HL-ColLeft');
//   	var clickOnMapRight = document.querySelector('.HL-ColRight');
  
//     clickOnMapLeft.addEventListener('click', () => {
//      storeinfo() 
//     });

// 	clickOnMapRight.addEventListener('click', () => {
//      storeinfo() 
//     });
// });


$(window).load(function() {
	storeinfo(); 
  	
  	$(".HL-ColLeft, .HL-ColRight").click(function(){
    storeinfo() 
  });


})